import React, { useEffect, useState } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/PageLayout";
import { FiX } from "react-icons/fi";

import {
  FormInput,
  FormTemplate,
  FormSelect,
  FormReadonlyTextArea,
  FormsSelect,
} from "../../../Components/Forms/InputTemplate";
import { FormProvider, useForm } from "react-hook-form";
import {
  ActionButtons,
  SupportButtons,
} from "../../../../global/components/Buttons/buttons";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAlLEmployees,
  GetAllBranches,
  // GetVendors, 
  GetVendorProcurements
} from "../../../../../utils/redux/Vendor/VendorSlice";
import {
  GetAssetType,
  GetVendorType,
} from "../../../../../utils/redux/Global/GlobalSlice";
import { useLocation, useNavigate, useParams } from "react-router";
import {
  CreateProcRequsition,
  GetProcBeneficiaries,
  GetProcDepartment,
  UpdateProcRequsition,
} from "../../../../../utils/redux/Procurement/ProcurementSlice";
import Table from "../../../Components/Table/Table";
import { TableActionsDownload } from "../../../Components/Misc/Actions";
import MultiSelect from "../../../Components/MultiSelect/MultiSelect";
import FormUploadComponent from "../../../Components/Forms/FormUploadComponent";
import {
  FormatDateTime,
  removeListData,
} from "../../../../../utils/functions/ResourceFunctions";
import { GetAssetClass } from "../../../../../utils/redux/AssetsSetUp/AssetSetUpSlice";
import { GetConsummableClass } from "../../../../../utils/redux/ConsummableSetUp/ConsummableSetUpSlice";
import { PROCUREMENT_TYPE } from "../../../../../utils/Enums";
import RequisitionBeneficiaries from "./RequisitionBeneficiaries";
import {
  GetDocumentDifinition,
  GetUnits,
} from "../../../../../utils/redux/HR/HRSlice";
import { toast } from "react-toastify";
// import { set } from "date-fns";
import CustomModal from "../../Finance/PayrollAutoRun/components/CustomModal";
import { Autocomplete, TextField } from "@mui/material";
import {
  useGetBudgetDetailsQuery,
  useGetBudgetSummaryQuery,
  useLinkBudgetToPaymentMutation,
} from "../../../../api";
import axios from "axios";
import { useVendorGetQuery } from "../../../../api/vendorApi";
import { useDocumentGetQuery } from "../../../../api/documentApi";
import { getExchangeRateSetup } from "../../../../../utils/redux/Finance/PaymentSetup/PaymentSetupSlice";
import { twMerge } from "tailwind-merge";

function AddEmployeeProcRequisition() {
  // get current year
  const dispatch = useDispatch();
  const currentYear = new Date().getFullYear();
  const location = useLocation()?.state;

  const hrRoot = process.env.REACT_APP_BACKEND_HR_URL;
  const token = JSON.parse(localStorage.getItem("user"))?.userToken;
  const [loading, setIsloading] = useState(false);
  const [assetItems, setAssetItems] = useState({});
  console.log('assetItems', assetItems)
  const [isYear, setIsYear] = useState(new Date().getFullYear());
  const [openBudgetModal, setOpenBudgetModal] = useState(false);
  const [pageNumber] = useState(1);
  const [pageSize] = useState(1000000);
  const [newBudgetData, setNewBudgetData] = useState([]);
  const [budgetId, setBudgetId] = useState();
  const [newBudgetId, setNewBudgetId] = useState();
  const [departmentValue, setDepartmentValue] = useState();
  const [budgetValue, setBudgetValue] = useState();
  const [sendNotif, setSendNotif] = useState(false);
  const [subClassesArray, setSubClassesArray] = useState([]);

  const { asset_class } = useSelector((state) => state?.assetSetUp);
  const { consummable_class } = useSelector((x) => x?.consummableSetUp);
  const { departments, isSubmitting } = useSelector((x) => x?.procurement);
  const state = useSelector((state) => state);



  // console.log("all Vendor", all_vendors);
  const data = useSelector((state) => state?.procurement);
  // const documentList = useSelector(
  //   (state) => state?.hr?.document_definition?.result
  // );
  const [documentList, setDocumentList] = useState([]);
  const { data: documents } = useDocumentGetQuery(
    `/Definitions?pageNumber=1&pageSize=10&Module=19&Search=Procurement`
  );
  const exchangeRates = useSelector(
    (state) => state?.paymentSetup?.exchangeRates?.responseObject?.items || []
  );
  // console.log("docuemtns", documents);
  useEffect(() => {
    setDocumentList(documents?.result);
  }, [documents]);
  const { data: budgetDetails } = useGetBudgetDetailsQuery({
    pageSize,
    pageNumber,
    SummaryId: budgetId,
  });

  const { data: budgetSummaryData } = useGetBudgetSummaryQuery({
    Year: currentYear,
    Department: departmentValue,
    pageSize,
    PageNumber: pageNumber,
  });

  const [uploadFile, setUploadFile] = useState(null);
  const [vendorDocument, setVendorDocument] = useState(
    location?.documents || []
  );

  const budgetData = budgetSummaryData?.result ?? [];

  const closeBudgetModal = () => {
    setOpenBudgetModal(false);
  };

  function createYearArray() {
    const currentYear = new Date().getFullYear();
    const lowestYear = 2002;
    const years = [];

    for (let year = currentYear; year >= lowestYear; year--) {
      years.push(year);
    }

    return years;
  }
  const yearArray = createYearArray();

  useEffect(() => {
    const getDepartment = async () => {
      try {
        const res = await axios.get(
          `${hrRoot}/Department/AllDepartment?&PageSize=${pageSize}&PageNumber=1`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (res) {
          setNewBudgetData(res?.data?.responseObject?.pageItems);
        }
      } catch (err) {
        console.log(err);
      }
    };
    getDepartment();
  }, [hrRoot, pageSize, token]);

  useEffect(() => {
    dispatch(
      GetAlLEmployees({
        pageSize: 100000,
        pageNumber: 1,
      })
    );
    dispatch(
      GetAssetType({
        filter: 2,
        pageSize: 10000,
        currentPage: 1,
        sort: 1,
      })
    );
    // dispatch(
    //   GetAssetRegister({
    //     filter: 2,
    //     pageSize: 10000,
    //     currentPage: 1,
    //     sort: 1,
    //   })
    // );

    // dispatch(
    //   GetConsummableRegister({
    //     pageSize: 100000,
    //     currentPage: 1,
    //     sort: 0,
    //     filter: 2,
    //   })
    // );
    dispatch(
      GetConsummableClass({
        pageSize: 100000,
        currentPage: 1,
        sort: 0,
        filter: 2,
        // CategoryId: 1,
      })
    );
    dispatch(GetVendorType());
    dispatch(GetProcBeneficiaries());
    dispatch(GetProcDepartment());
    dispatch(GetAllBranches());

    // return branches
    dispatch(GetUnits({ TypeOfContainer: 2, PageSize: 100, PageNumber: 1 }));

    dispatch(
      GetAssetClass({
        pageSize: 100000,
        currentPage: 1,
        sort: 0,
        filter: 0,
        // CategoryId: 1,
      })
    );

    dispatch(
      getExchangeRateSetup({
        pageSize: 10000,
        pageNumber: 1,
        // ApprovalStatus: approvalStatus === "all" ? "" : approvalStatus,
      })
    );
  }, [dispatch]);

  const defaultData = {
    AssetBrand: location?.assetBrand || "",
    VendorType: location?.vendorType || "",
    RequisitionType: location?.procurementTypeId,
    Description: location?.description,
    beneficiaries: location?.beneficiaryEl || [
      {
        branch: "",
        department: "",
        branchId: "",
        departmentId: "",
        beneficiaryName: "",
        Quantity: "",
        beneficiaryType: "",
      },
    ],
    AssetId: location?.assetId,
    Deadline: FormatDateTime(location?.deadline, "DD/MM/YYYY"),
    vendors: location?.vendors?.map((x) => x?.id?.toString()),
    AssetClassName: location?.assetClassName || "",
    AssetSubClassName: location?.assetSubClassName || "",
  };


  const formMethods = useForm({
    defaultValues: defaultData,
    mode: "all",
  });
  const {
    handleSubmit,
    setValue,
    getValues,
    reset,
    watch,
    formState: { isValid },
  } = formMethods;

  const { id } = useParams();

  const navigate = useNavigate();

  const [flipData, setFlipData] = useState(getValues("RequisitionType") || 0);

  const isFound = location?.isFound;

  const submit = (data) => {
    const AssetClassNameA = asset_class?.responseObject?.find(
      (x) => +x?.id === +data?.AssetClass
    );
    const AssetSubClassNameA = AssetClassNameA?.subClasses?.find(
      (x) => +x?.id === +data?.AssetSubClass
    );

    const totalData = {
      ...data,
      id: id || "",
      Status: 1,
      // AssetType: 1,
      AssetName:
        assetItems?.name ||
        isFound?.assetName ||
        isFound?.itemName ||
        data?.AssetName,
      AssetSpecification: data?.Description,
      AssetBrand: data?.AssetBrand || assetItems?.brand || "Greatness",
      AssetId: +data?.AssetId,
      AssetType: data?.AssetType || isFound?.categoryId,
      AssetTypeName: data?.AssetTypeName || isFound?.category,
      SendNotification: data?.SendNotification ? true : false,
      AssetClass: data?.AssetClass,
      AssetSubClass: data?.AssetSubClass,
      AssetClassName:
        flipData === PROCUREMENT_TYPE.Consummable
          ? data?.AssetClassName
          : AssetClassNameA?.name,
      AssetSubClassName:
        flipData === PROCUREMENT_TYPE.Consummable
          ? data?.AssetSubClassName
          : AssetSubClassNameA?.name,
      RequisitionType: +data?.RequisitionType,
      BudgetId: newBudgetId?.id,
      // SendNotification: sendNotif,
      UserId: JSON.parse(localStorage.getItem("user"))?.userId,
    };

    const dataVendors = Array.isArray(data.vendors)
      ? data.vendors
      : [data.vendors];
    const vendors =
      all_vendors?.result?.length === 1
        ? all_vendors?.result
          ?.filter?.((elem) => +data?.vendors === +elem?.id)
          ?.map((x) => {
            return {
              vendorId: x?.id,
              vendorEmail: x?.email,
              vendorName: x?.businessName,
            };
          })
        : all_vendors?.result
          ?.filter?.((elem) => {
            return dataVendors?.some?.((ele) => {
              return +ele === elem?.id;
            });
          })
          ?.map((x) => {
            return {
              vendorId: x?.id,
              vendorEmail: x?.email,
              vendorName: x?.businessName,
            };
          });

    console.log("vendors", vendors);

    const fileData = new FormData();
    const key = Object.keys(totalData).filter((key) => totalData[key]);

    const removedKey = ["beneficiaries", "vendors"];

    const removedUnwantedKey = key
      ?.map((x) => x)
      ?.filter((x) => !removedKey.includes(x));

    removedUnwantedKey?.forEach((key, index) => {
      fileData.append(`${key}`, totalData[key]);
    });

    totalData?.beneficiaries?.forEach((key, index) => {
      fileData.append(
        `Beneficiaries[${index}].department`,
        key?.department || ""
      );
      fileData.append(
        `Beneficiaries[${index}].departmentId`,
        key?.departmentId || ""
      );
      fileData.append(`Beneficiaries[${index}].quantity`, key?.quantity || 0);
      fileData.append(`Beneficiaries[${index}].branch`, key?.branch || "");
      fileData.append(`Beneficiaries[${index}].branchId`, key?.branchId || "");
      fileData.append(
        `Beneficiaries[${index}].beneficiaryName`,
        key?.beneficiaryName || ""
      );
      fileData.append(
        `Beneficiaries[${index}].beneficiaryType`,
        +key?.beneficiaryType
      );
    });

    vendors?.forEach((key, index) => {
      fileData.append(`Vendors[${index}].id`, key?.vendorId || "");
      fileData.append(`Vendors[${index}].email`, key?.vendorEmail || "");
      fileData.append(`Vendors[${index}].companyName`, key?.vendorName || "");
    });

    // Construct the array of documents in the required format
    const documentArray = vendorDocument.map((element) => {
      const matchedDocument = documentList.find(
        (doc) => doc?.name === element?.fileName
      );

      return {
        id: matchedDocument?.id || 0,
        definitionId: matchedDocument?.id || 0,
        file: element?.file, // File blob or content
      };
    });

    // Instead of appending the entire array as a JSON string, append each element individually
    documentArray.forEach((element, index) => {
      // fileData.append(`UploadDocuments[${index}].id`, element.id);
      fileData.append(
        `UploadDocuments[${index}].definitionId`,
        element.definitionId
      );
      fileData.append(
        `UploadDocuments[${index}].file`,
        element.file,
        element.file?.name
      );
    });

    location
      ? dispatch(UpdateProcRequsition(fileData))?.then((res) => {
        if (res?.payload?.successful === true) {
          reset();
          navigate(`../${id}/view`);
        } else {
          toast.error(res?.payload?.statusMessage);
        }
      })
      : dispatch(CreateProcRequsition(fileData))?.then((res) => {
        if (res?.payload?.successful === true) {
          reset();
          navigate(`../${res?.payload?.responseObject?.id}/view`);
        } else {
          toast.error(res?.payload?.statusMessage);
        }
      });

    // console.log(fileData);
  };

  const handleCheckboxChange = (e) => {
    setSendNotif(e.target.checked); // Set sendNotif to true or false based on checkbox
  };
  // console.log({ location, isFound });

  useEffect(() => {
    setAssetItems(isFound);
  }, [isFound]);

  // console.log({ location, isFound, assetItems }); 
  const all_vendors = useSelector((state) => state?.vendor?.all_vendor_procurement);
  const serviceProvidingId = watch("AssetId");
  useEffect(() => {
    // location?.isFound &&
    dispatch(
      GetVendorProcurements({
        PageSize: 999999999,
        CurrentPage: 1,
        sort: 1,
        ServiceProvidingId: serviceProvidingId,
        ServiceType: flipData === PROCUREMENT_TYPE.Asset ? 0 : 1,
      })
    );
    // setValue("Description", isFound?.description || isFound?.specification);
    // setValue("AssetType", isFound?.categoryId);
    // setValue("AssetTypeName", isFound?.category);
  }, [dispatch, location, isFound, setValue, flipData, serviceProvidingId]);

  const watchUnitPrice = watch("UnitPrice");
  const watchQuantity = watch("Quantity");
  const watchDelivery = watch("DeliveryCost");

  const calculateTotalPrice = () => {
    const valueWithQuantity =
      +watchUnitPrice * +(watchQuantity || 1) + +watchDelivery;
    const valueWithOutQuantity = +watchUnitPrice + +watchDelivery;

    if (+(watchQuantity || 1) === 0) {
      return setValue("TotalPrice", valueWithOutQuantity);
    }

    return setValue("TotalPrice", valueWithQuantity);
  };

  useEffect(() => {
    calculateTotalPrice();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchUnitPrice, watchQuantity, watchDelivery]);

  const [onLinkBudget] = useLinkBudgetToPaymentMutation();
  const handleLinkBudget = async () => {
    // console.log(budgetId);
    // console.log(newBudgetId);
    // try {
    //   setIsloading(true);
    //   const res = await onLinkBudget({
    //     BatchId: vendor?.uniqueIdentifier,
    //     BudgetId: newBudgetId,
    //   }).unwrap();
    //   if (res.successful === true) {
    //     setIsloading(false);
    //     setOpenBudgetModal(false);
    //     toast.success(res?.statusMessage);
    //   }
    // } catch (err) {
    //   setIsloading(false);
    //   // setOpenBudgetModal(false);
    //   // handleClose();
    //   // setOpenModal(false);
    //   toast.error(err?.data?.statusMessage);
    // }
  };

  const handleBudgetModal = () => {
    setOpenBudgetModal(true);
    // setPopover(null);
  };

  useEffect(() => {
    dispatch(
      GetDocumentDifinition({
        pageNumber: 1,
        pageSize: 10,
        Module: 19,
        Search: "Procurement",
      })
    );
  }, [dispatch]);

  return (
    <PageLayout
      title={location ? "Edit Requisition" : "Add Requisition"}
      hasBack={true}
    >
      <FormProvider {...formMethods}>
        <FormTemplate
          className={DashboardStyle.view_app_components}
          handleSubmit={handleSubmit(submit)}
        >
          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>
              Requisition <br /> Information
            </h4>
            <div className={DashboardStyle.inputs_group}>
              <div>
                <FormSelect
                  className="col-span-2 sm:col-span-2"
                  title={"Procurement Type"}
                  camelCase={"ProcurementType"}
                  placeholder={"Auto Generated"}
                  disabled={false}
                  array={
                    <>
                      <option value={0}>Employee</option>
                      <option value={1}>Committee</option>
                      <option value={2}>Operations</option>
                      <option value={3}>Director</option>
                      <option value={4}>Float</option>
                    </>
                  }
                  moreRegister={{
                    onChange: (e) => {
                      // setFlipData(+e.target.value);
                      // setValue("Description", "");
                    },
                  }}
                // isOptional={true}
                />
              </div>

              <div>
                <FormSelect
                  className="col-span-2 sm:col-span-1"
                  title={"Requisition Type"}
                  camelCase={"RequisitionType"}
                  placeholder={"Auto Generated"}
                  disabled={false}
                  array={
                    <>
                      <option value={0}>Asset</option>
                      <option value={1}>Consumable</option>
                    </>
                  }
                  moreRegister={{
                    onChange: (e) => {
                      setFlipData(+e.target.value);
                      setValue("Description", "");
                      setValue("vendors", [])
                    },
                  }}
                // isOptional={true}
                />

                {flipData === PROCUREMENT_TYPE.Consummable && (
                  <>
                    <FormSelect
                      className="col-span-2 sm:col-span-1"
                      title={"Consumable Class"}
                                          defaultValue={"Select Consumable Class"}
                    defaultId={-1}
                      camelCase={"ConsumableClass"}
                      placeholder={"select"}
                      array={consummable_class?.responseObject
                        ?.filter((x) => {
                          return (
                            x.categorySubClass && x.categorySubClass.length > 0
                          );
                        })
                        ?.map?.((x, index) => (
                          <option key={index} value={x?.id}>
                            {x?.name}
                          </option>
                        ))}
                      moreRegister={{
                        onChange: (e) => {
                          setValue("vendors", [])
                          const isFoundData =
                            consummable_class?.responseObject?.find(
                              (x) => +e.target.value === +x?.id
                            );
                          // console.log(1, { isFoundData });
                          // setValue("AssetName", isFoundData?.itemName);
                          setValue("AssetType", isFoundData?.categoryId);
                          setValue("AssetTypeName", isFoundData?.categoryName);
                          setValue("AssetBrand", isFoundData?.assetBrand);
                          setValue("AssetClassName", isFoundData?.name);
                          setValue("AssetSubClassName", isFoundData?.categorySubClass?.[0]?.name);

                          // setValue(
                          //   "AssetSubClassName",
                          //   isFoundData?.consumableSubClass
                          // );
                          setValue(
                            "Description",
                            isFoundData?.specification
                              ? isFoundData?.specification
                              : isFoundData?.name
                          );
                          setSubClassesArray(
                            isFoundData?.categorySubClass?.map((x) => {
                              return {
                                // class: isFoundData.name,
                                ...isFoundData,
                                ...x,
                              };
                            })
                          );
                          // setAssetItems(isFoundData);
                          return;
                        },
                      }}
                    />

                    <FormSelect
                      className="col-span-2"
                      title={"Consumable Name"}
                      camelCase={"AssetId"}
                      placeholder={"select"}
                      array={subClassesArray?.map?.((x, index) => (
                        <option key={index} value={x?.id}>
                          {x?.name}
                        </option>
                      ))}
                      moreRegister={{
                        onChange: (e) => {
                          setValue("vendors", [])
                          const isFoundData = subClassesArray?.find(
                            (x) => +e.target.value === +x?.id
                          );
                          // console.log("isFoundData", isFoundData);
                          // setValue(
                          //   "Description",
                          //   isFoundData?.specification
                          //     ? isFoundData?.specification
                          //     : isFoundData?.name
                          // );
                          setValue("AssetName", isFoundData?.name);
                          // setValue("AssetBrand", isFoundData?.assetBrand);
                          setValue("AssetSubClassName", isFoundData?.name);
                          setAssetItems({
                            subClassId: isFoundData.id,
                            ...isFoundData,
                          });
                          // dispatch(
                          // //   GetVendors({
                          // //     filter: 2,
                          // //     PageSize: 10000,
                          // //     CurrentPage: 1,
                          // //     sort: 1,
                          // //     SubClass: isFoundData?.id,
                          // //   })

                          // );
                          return;
                        },
                      }}
                    />
                  </>
                )}

                {flipData === PROCUREMENT_TYPE.Asset && (
                  <>
                    <FormSelect
                      className="col-span-2 sm:col-span-1"
                                          defaultValue={"Select Asset Class"}
                    defaultId={-1}
                      title={"Asset Class"}
                      camelCase={"AssetClass"}
                      placeholder={"select"}
                      array={asset_class?.responseObject
                        ?.filter((x) => {
                          return x.subClasses && x.subClasses.length > 0;
                        })
                        ?.map?.((x, index) => (
                          <option key={index} value={+x?.id}>
                            {x?.name}
                          </option>
                        ))}
                      moreRegister={{
                        onChange: (e) => {
                          setValue("vendors", [])
                          const isFoundData = asset_class?.responseObject?.find(
                            (x) => +e.target.value === +x?.id
                          );

                          // console.log(1, { isFoundData });
                          if (isFoundData) {
                            setValue("Description", isFoundData?.description);
                            setValue("AssetType", isFoundData?.categoryId);
                            setValue("AssetTypeName", isFoundData?.category);
                            setValue("AssetBrand", isFoundData?.assetBrand);
                            // setValue(
                            //   "AssetSubClass",
                            //   isFoundData?.assetSubClassId
                            // );
                            // setValue("AssetClass", isFoundData?.assetClassId);
                            setSubClassesArray(
                              isFoundData?.subClasses.map((x) => {
                                return { ...isFoundData, ...x };
                              })
                            );
                            
                          }
                        },
                      }}
                    />
                    <FormSelect
                      className="col-span-2"
                      title={"Asset Name"}
                      camelCase={"AssetId"}
                      placeholder={"select"}
                      array={subClassesArray?.map?.((x, index) => (
                        <option key={index} value={x?.id}>
                          {x?.name}
                        </option>
                      ))}
                      moreRegister={{
                        onChange: (e) => {
                          setValue("vendors", [])

                          const isFoundData = subClassesArray?.find(
                            (x) => +e.target.value === x?.id
                          );

                          // console.log(2, { isFoundData, subClassesArray });
                          setAssetItems({
                            subClassId: isFoundData.id,
                            ...isFoundData,
                          });
                          // dispatch(
                          //   GetVendors({
                          //     filter: 2,
                          //     PageSize: 10000,
                          //     CurrentPage: 1,
                          //     sort: 1,
                          //     SubClass: isFoundData?.id,
                          //   })
                          // );

                          setValue("AssetSubClass", isFoundData?.id);
                          return;
                        },
                      }}
                    />
                  </>
                )}
              </div>

              <div>
                {/* title={"Asset Specification"} */}
                <FormReadonlyTextArea
                  title={"Description"}
                  camelCase={"Description"}
                  // placeholder={"Asset Description"}
                  type="textbox"
                  isOptional={false}
                  disabled={"disabled"}
                />
                {flipData !== PROCUREMENT_TYPE.Asset && (
                  <>
                    {assetItems?.category?.toLowerCase() ===
                      PROCUREMENT_TYPE.Consummable_Type?.Goods && (
                        <FormInput
                          title={"Quantity"}
                          camelCase={"quantity"}
                          placeholder={"Enter Quantity"}
                        // isOptional={true}
                        />
                      )}
                  </>
                )}
                <FormInput
                  title={"Deadline"}
                  camelCase={"Deadline"}
                  placeholder={"Enter Deadline"}
                  type={"date"}
                // isOptional={true}
                />
              </div>

              {/* <div>
                <FormSelect
                  title={"Asset Class"}
                  camelCase={"AssetClass"}
                  placeholder={"Auto Generated"}
                  disabled={true}
                  array={asset_class?.responseObject?.map?.((x, index) => (
                    <option key={index} value={+x?.id}>
                      {x?.name}
                    </option>
                  ))}
                  moreRegister={{
                    onChange: (e) => {
                      const isFound = asset_class?.responseObject?.find(
                        (x) => +e.target.value === +x?.id
                      );
                      setSubClassesArray(isFound?.subClasses);
                    },
                  }}
                  // isOptional={true}
                />

                <FormSelect
                  title={"Asset SubClass"}
                  camelCase={"AssetSubClass"}
                  placeholder={"Auto Generated"}
                  disabled={true}
                  array={subClassesArray?.map?.((x, index) => (
                    <option key={index} value={+x?.id}>
                      {x?.name}
                    </option>
                  ))}
                  // isOptional={true}
                />
              </div> */}
            </div>
          </section>

          <RequisitionBeneficiaries
            assetItems={assetItems}
            flipData={flipData}
          />

          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>
              Vendor <br /> Information
            </h4>
            <div className={DashboardStyle.inputs_group}>
              <div style={{ gridTemplateColumns: "1fr" }}>
                <MultiSelect
                  data={
                    // flipData === PROCUREMENT_TYPE.Consummable
                    //   ? all_vendors?.result
                    //       ?.filter((vendor) => {
                    //         if (vendor?.serviceProvideConsumable?.length > 0) {
                    //           console.log(
                    //             "shshgsggs",
                    //             vendor.email,
                    //             vendor?.serviceProvideConsumable,
                    //             assetItems?.subClassId
                    //           );
                    //         }

                    //         const hasServiceProvideConsumable =
                    //           vendor?.serviceProvideConsumable?.some(
                    //             (asset) => Number(asset.id) === Number(assetItems?.subClassId)
                    //           );
                    //         // console.log(
                    //         //   "this is the asset",
                    //         //   assetItems?.subClassId
                    //         // );

                    //         return hasServiceProvideConsumable;
                    //       })
                    //       .map((x) => {
                    //         return {
                    //           name: x?.businessName,
                    //           checkBoxName: x?.businessName,
                    //           id: x?.id,
                    //           ...x,
                    //         };
                    //       })
                    //   : flipData === PROCUREMENT_TYPE.Asset
                    //   ? all_vendors?.result
                    //       ?.filter((vendor) => {

                    //         const hasServiceProvideConsumable =
                    //           vendor?.serviceProvideAsset?.some(
                    //             (asset) => Number(asset.id) === Number(assetItems?.subClassId)
                    //           );
                    //         // console.log(
                    //         //   "this is the vendor asset",
                    //         //   assetItems?.subClassId
                    //         // );

                    //         return hasServiceProvideConsumable;
                    //       })
                    all_vendors?.result?.map((x) => {
                      return {
                        name: x?.businessName,
                        checkBoxName: x?.businessName,
                        id: x?.id,
                        ...x,
                      };
                    })
                    // : ["hello"]
                  }
                  dataValues={
                    all_vendors?.result?.length === 1
                      ? [watch()?.vendors]
                      : watch()?.vendors || location?.vendors?.map((x) => x?.id)
                  }
                  name={"vendors"}
                  title={"Vendors"}
                />
              </div>
            </div>
          </section>

          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>
              Budget details
            </h4>
            <div className={DashboardStyle.inputs_group}>
              {/* <div style={{ gridTemplateColumns: "1fr" }}>
                <MultiSelect
                  data={
                    flipData === PROCUREMENT_TYPE.Consummable
                      ? all_vendors?.result
                          ?.filter((vendor) => {
                            const hasServiceProvideConsumable =
                              vendor?.serviceProvideConsumable?.some(
                                (asset) => asset.id === assetItems?.subClassId
                              );
                            console.log(
                              "this is the asset",
                              assetItems?.subClassId
                            );

                            return hasServiceProvideConsumable;
                          })
                          .map((x) => {
                            return {
                              name: x?.businessName,
                              checkBoxName: x?.businessName,
                              id: x?.id,
                              ...x,
                            };
                          })
                      : flipData === PROCUREMENT_TYPE.Asset
                      ? all_vendors?.result
                          ?.filter((vendor) => {
                            const hasServiceProvideConsumable =
                              vendor?.serviceProvideAsset?.some(
                                (asset) =>
                                  asset.id === assetItems?.assetSubClassId
                              );
                            console.log(
                              "this is the asset",
                              assetItems?.assetSubClassId
                            );

                            return hasServiceProvideConsumable;
                          })
                          .map((x) => {
                            return {
                              name: x?.businessName,
                              checkBoxName: x?.businessName,
                              id: x?.id,
                              ...x,
                            };
                          })
                      : ["hello"]
                  }
                  dataValues={
                    all_vendors?.result?.length === 1
                      ? [watch()?.vendors]
                      : watch()?.vendors || location?.vendors?.map((x) => x?.id)
                  }
                  name={"vendors"}
                  title={"Vendors"}
                />
              </div> */}
              <button
                className="p-3 border border-red-500"
                onClick={handleBudgetModal}
              >
                Add Budget Details
              </button>
              <div className="grid grid-cols-2 gap-5">
                <div className="w-full mb-5">
                  <h1 className="text-baseFont text-customGreen mb-2">
                    Department <span className="text-red-500">*</span>
                  </h1>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={newBudgetData?.map((d, _index) => ({
                      label: d?.name,
                      value: d?.name,
                      id: d?.id,
                      key: _index,
                    }))}
                    getOptionLabel={(option) => option?.label}
                    onChange={(e, newValue) => {
                      // console.log(newValue);
                      setDepartmentValue(newValue?.value || "");
                      // setIsId(newValue?.id || "");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        value={departmentValue}
                        placeholder="Choose Department"
                      />
                    )}
                  />
                </div>
                {/* <div className="w-full mb-5">
                  <h1 className="text-baseFont text-customGreen mb-2">Year</h1>
                  <select
                    className="text-baseFont w-full py-3 rounded border border-slate-300 bg-white  h-[50px] px-2 outline-none focus:ring-0"
                    onChange={(e) => setIsYear(e.target.value)}
                    // value={payrollType}
                  >
                    {yearArray.map((year, index) => (
                      <option key={index} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div> */}
                <div className="w-full mb-5">
                  <h1 className="text-baseFont text-customGreen mb-2">
                    Budget <span className="text-red-500">*</span>
                  </h1>
                  <Autocomplete
                    disablePortal
                    disabled={budgetData?.length < 1}
                    id="combo-box-demo"
                    options={budgetData.map((d, _index) => ({
                      label: `Budget for ${d?.department} for year ${d?.year}`,
                      value: d?.name,
                      id: d?.id,
                      key: _index,
                    }))}
                    getOptionLabel={(option) => option?.label}
                    onChange={(e, newValue) => {
                      setBudgetValue(newValue?.value || "");
                      setBudgetId(newValue?.id || "");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        value={budgetValue}
                        placeholder={
                          budgetData?.length < 1
                            ? `No budget for ${departmentValue}`
                            : "Choose budget"
                        }
                      />
                    )}
                  />
                </div>
                <div className="w-full mb-5">
                  <h1 className="text-baseFont text-customGreen mb-2">
                    Budget Item <span className="text-red-500">*</span>
                  </h1>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    disabled={!budgetDetails?.result}
                    options={budgetDetails?.result?.map((d, _index) => ({
                      label: d?.item + " - " + d?.description,
                      value: d.item,
                      key: _index,
                      id: d.id,
                      details: d,
                    }))}
                    onChange={(e, newValue) => {
                      // console.log(newValue);
                      setNewBudgetId(newValue?.details || "");
                    }}
                    renderInput={(params) => (
                      <TextField {...params} placeholder="Choose budget item" />
                    )}
                  />
                </div>
              </div>

              {newBudgetId && (
                <div className="flex gap-6 ">
                  <label className="flex  flex-col gap-1 flex-1 ">
                    Total
                    <input
                      disabled
                      type="text"
                      value={newBudgetId?.total}
                      className="border p-2"
                    />
                  </label>
                  <label className="flex  flex-col gap-1 flex-1 ">
                    Amount Remaining
                    <input
                      disabled
                      type="text"
                      value={
                        newBudgetId?.total - newBudgetId?.actualExpenditure
                      }
                      className="border p-2"
                    />
                  </label>
                </div>
              )}

              {newBudgetId?.total - newBudgetId?.actualExpenditure === 0 && (
                <label className="flex gap-2 items-center">
                  <input
                    type="checkbox"
                    checked={sendNotif}
                    onChange={handleCheckboxChange}
                  />
                  Budget remaining is less than Budget. a notification will be
                  sent
                </label>
              )}

              {/* <div className="w-full flex items-center justify-end gap-5 pt-3 px-7">
              <button
                className=" px-[24px] py-[12px] rounded-[8px] text-baseFont text-customGreen"
                style={{ border: "1px solid #305f32" }}
                onClick={closeBudgetModal}
              >
                Cancel
              </button>
              <button
                onClick={handleLinkBudget}
                disabled={loading}
                className="bg-[#29382A] text-white px-[24px] py-[12px] rounded-[8px]"
              >
                {loading ? "Updating..." : "Update to Budget"}
              </button>
            </div> */}
            </div>
          </section>
  <p className="text-sm text-black font-medium text-center">
            Provide the quotation details if you already have an invoice from the vendor.
            This will eliminate the need for the vendor to submit a separate quotation. Also make sure Proc Quotation document is uploaded
          </p>
          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>
              Your Quotation
             </h4>
            <div className={DashboardStyle.inputs_group}>
              <div>
                <FormInput
                  title={"Unit Price"}
                  camelCase={"UnitPrice"}
                  placeholder={"Enter Unit Price"}
                  isOptional={true}
                />
                {/* <FormInput
                            title={"Quantity"}
                            camelCase={"Quantity"}
                            // disabled={true}
                            isOptional={true}
                            // placeholder={"Enter City"}
                            defaultValue={proc_req?.quantity}
                          /> */}
                <FormInput
                  title={"Delivery Cost"}
                  camelCase={"DeliveryCost"}
                  isOptional={true}
                  placeholder={"Enter Delivery Cost"}
                />
              </div>
              <div
                className={twMerge(
                  "flex flex-row w-full gap-3",
                  watch("Currency")?.toUpperCase() === "NGN"
                    ? "col-span-2"
                    : "col-span-2 xl:col-span-1"
                )}
              >
                <div className="w-full">
                  <FormsSelect
                    title={"Currency"}
                    camelCase={"Currency"}
                    placeholder={"- Select -"}
                    array={exchangeRates?.map((x, index) => (
                      <option key={index} value={x?.currency}>
                        {x?.currency}
                      </option>
                    ))}
                    isOptional={true}
                    moreRegister={{
                      onChange: (e) => {
                        const isFound = exchangeRates?.find(
                          (x) => x?.currency === e.target.value
                        );
                        console.log("e", e.target.value, isFound);
                        setValue("ExchangeRate", isFound?.exchangeRateValue);
                        // dispatch(
                        //   GetAllPaymentSubclassComp({
                        //     pageSize: 10000,
                        //     pageNumber: 1,
                        //     PaymentSetupSubClassId: isFound?.id,
                        //   })
                        // );
                      },
                    }}
                  />
                </div>

                <div>
                  <FormInput
                    title={"Exchange Rate"}
                    camelCase={"ExchangeRate"}
                    disabled={watch("Currency")?.toUpperCase() === "NGN"}
                    type={"number"}
                    defaultValue={1}
                    isOptional={true}
                    className={"w-full col-span-2"}
                  />
                </div>
              </div>
              <div>
                <FormSelect
                  title={"Warranty"}
                  camelCase={"Waranty"}
                  placeholder={"Enter Waranty"}
                  isOptional={true}
                  array={
                    <>
                      {/* <option value="quarterly">Quarterly</option> */}
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </>
                  }
                />
                <FormInput
                  title={"Total Quote"}
                  camelCase={"TotalPrice"}
                  placeholder={"Enter Total Price"}
                  disabled={true}
                  isOptional={true}
                />
              </div>
              <div>
                <FormSelect
                  title={"Support Included"}
                  camelCase={"SupportIncluded"}
                  placeholder={"Enter City"}
                  isOptional={true}
                  array={
                    <>
                      <option value={1}>Yes</option>
                      <option value={2}>No</option>
                    </>
                  }
                />
                <FormInput
                  title={"Delivery Schedule"}
                  camelCase={"DeliverySchedule"}
                  placeholder={"Enter Delivery Schedule"}
                  type={"date"}
                  isOptional={true}
                />
              </div>
            </div>
          </section>

          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>
              Documents Upload
            </h4>
            <div className={DashboardStyle.inputs_group_no_grid}>
              <FormUploadComponent
                documentList={documentList}
                uploadFile={uploadFile}
                setUploadFile={setUploadFile}
                setVendorDocument={setVendorDocument}
                vendorDocument={vendorDocument}
                canSelectDuplicate={true}
              />
            </div>
          </section>
          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>
              Documents <br /> Uploads
            </h4>
            <div
              className={` ${DashboardStyle.labels_group} ${DashboardStyle.labels_group_downloads} `}
            >
              {vendorDocument?.length === 0 ? (
                <p>No Record Available</p>
              ) : (
                <Table>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>File Name</th>
                      <th>File Type</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vendorDocument?.map?.((x, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{x?.file?.name || x?.fileName}</td>
                          <td style={{ textTransform: "uppercase" }}>
                            {x?.value || x?.fileName}
                          </td>
                          <td>
                            <TableActionsDownload
                              file={x?.file || null}
                              url={x?.fileUrl || null}
                              actions={() =>
                                removeListData({
                                  value: index,
                                  list: vendorDocument,
                                  setList: setVendorDocument,
                                })
                              }
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              )}
            </div>
          </section>

          <div className={DashboardStyle.button_cage}>
            <SupportButtons
              width={"auto"}
              onClick={() => navigate(-1)}
              className={DashboardStyle?.button_cage_weight}
            >
              Cancel
            </SupportButtons>
            <ActionButtons
              width={"auto"}
              isLoading={isSubmitting}
              // disabled={!isValid}
              className={DashboardStyle?.button_cage_weight}
            >
              Submit
              {/* {isLoadingAction ? "Submitting..." : "Submit"} */}
            </ActionButtons>
          </div>
        </FormTemplate>
      </FormProvider>

      {openBudgetModal && (
        <CustomModal hideModal={setOpenBudgetModal}>
          <div
            className="bg-white w-full overflow-hidden"
            style={{
              borderTopLeftRadius: "5px",
              borderTopRightRadius: "5px",
            }}
          >
            <header className="w-full py-3 bg-customGreen px-4 flex items-center justify-between">
              <p className="text-white text-baseFont font-[700]">
                Update Budget
              </p>
              <button
                onClick={closeBudgetModal}
                className="text-baseFont text-white"
              // onClick={closeModal}
              >
                <FiX />
              </button>
            </header>
            {/*main*/}
            <div className="grid grid-cols-2 gap-5 p-8">
              <div className="w-full mb-5">
                <h1 className="text-baseFont text-customGreen mb-2">
                  Department
                </h1>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={newBudgetData?.map((d, _index) => ({
                    label: d?.name,
                    value: d?.name,
                    id: d?.id,
                    key: _index,
                  }))}
                  getOptionLabel={(option) => option?.label}
                  onChange={(e, newValue) => {
                    // console.log(newValue);
                    setDepartmentValue(newValue?.value || "");
                    // setIsId(newValue?.id || "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      value={departmentValue}
                      placeholder="Choose Department"
                    />
                  )}
                />
              </div>
              <div className="w-full mb-5">
                <h1 className="text-baseFont text-customGreen mb-2">Year</h1>
                <select
                  className="text-baseFont w-full py-3 rounded border border-slate-300 bg-white  h-[50px] px-2 outline-none focus:ring-0"
                  onChange={(e) => setIsYear(e.target.value)}
                // value={payrollType}
                >
                  {yearArray.map((year, index) => (
                    <option key={index} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
              <div className="w-full mb-5">
                <h1 className="text-baseFont text-customGreen mb-2">Budget</h1>
                <Autocomplete
                  disablePortal
                  disabled={budgetData?.length < 1}
                  id="combo-box-demo"
                  options={budgetData.map((d, _index) => ({
                    label: `Budget for ${d?.department} for year ${d?.year}`,
                    value: d?.name,
                    id: d?.id,
                    key: _index,
                  }))}
                  getOptionLabel={(option) => option?.label}
                  onChange={(e, newValue) => {
                    setBudgetValue(newValue?.value || "");
                    setBudgetId(newValue?.id || "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      value={budgetValue}
                      placeholder={
                        budgetData?.length < 1
                          ? `No budget for ${departmentValue}`
                          : "Choose budget"
                      }
                    />
                  )}
                />
              </div>
              <div className="w-full mb-5">
                <h1 className="text-baseFont text-customGreen mb-2">
                  Budget Item
                </h1>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  disabled={!budgetDetails?.result}
                  options={budgetDetails?.result?.map((d, _index) => ({
                    label: d?.item,
                    value: d.item,
                    key: _index,
                    id: d.id,
                    details: d,
                  }))}
                  onChange={(e, newValue) => {
                    // console.log(newValue);
                    setNewBudgetId(newValue?.details || "");
                  }}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Choose budget item" />
                  )}
                />
              </div>
            </div>
            <div className="w-full flex items-center justify-end gap-5 pt-3 px-7">
              <button
                className=" px-[24px] py-[12px] rounded-[8px] text-baseFont text-customGreen"
                style={{ border: "1px solid #305f32" }}
                onClick={closeBudgetModal}
              >
                Cancel
              </button>
              <button
                onClick={handleLinkBudget}
                disabled={loading}
                className="bg-[#29382A] text-white px-[24px] py-[12px] rounded-[8px]"
              >
                {loading ? "Updating..." : "Update to Budget"}
              </button>
            </div>
          </div>
        </CustomModal>
      )}
    </PageLayout>
  );
}

export default AddEmployeeProcRequisition;
